import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import { IKpiTemplate } from '@/types/kpi-template.types';

const BASE = `${env.apiTasklistBaseUrl}/api/v1/compro/kpi-templates`;
export interface IKpiTemplateChildRole {
  id: number;
  name: string;
}

export async function getKpiTemplates(tenantId: string | number, params?: Record<string, unknown> | null) {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}`, { params });
  return data;
}

export async function getKpiTemplateDetail(tenantId: string | number, id: string | number) {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}/${id}`);
  return data;
}

export async function createKpiTemplate(tenantId: string | number, payload: Partial<IKpiTemplate>) {
  const { data } = await axiosInstance.post(`${BASE}/tenant/${tenantId}`, payload);
  return data;
}

export async function updateKpiTemplate(
  tenantId: string | number,
  id: string | number,
  payload: Partial<IKpiTemplate>,
) {
  const { data } = await axiosInstance.put(`${BASE}/tenant/${tenantId}/${id}`, payload);
  return data;
}

export async function deleteKpiTemplate(tenantId: string | number, id: string | number) {
  const { data } = await axiosInstance.delete(`${BASE}/tenant/${tenantId}/${id}`);
  return data;
}

export async function getKpiTemplateChildRoles(tenantId: string | number): Promise<IKpiTemplateChildRole[]> {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}/roles/my-children`);
  return data?.data ?? [];
}
